(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const rotators = document.querySelectorAll('[data-rotator]');
    rotators.forEach(rotator => {
      const items = rotator.querySelectorAll('[data-rotate-item]');
      if (items.length <= 1) return;

      let current = 0;

      setInterval(() => {
        const cur = items[current];
        const next = (current + 1) % items.length;
        const nxt = items[next];

        cur.classList.add('announcement-bar__item--exit');
        cur.classList.remove('announcement-bar__item--hidden');

        nxt.classList.add('announcement-bar__item--hidden');
        nxt.classList.remove('announcement-bar__item--exit');
        void nxt.offsetWidth;
        nxt.classList.remove('announcement-bar__item--hidden');

        current = next;
      }, 3500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const openBtn = document.querySelector('[data-menu-open]');
    const closeBtn = document.querySelector('[data-menu-close]');
    const overlay = document.querySelector('[data-menu-overlay]');
    const menu = document.querySelector('[data-menu]');
    
    function openMenu() {
      if(menu) menu.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeMenu() {
      if(menu) menu.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.documentElement.style.overflow = '';
    }

    if(openBtn) openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    if(menu) {
      menu.querySelectorAll('[data-menu-close]').forEach(el => {
        if (el.tagName === 'A') el.addEventListener('click', closeMenu);
      });
    }

    // Header hide-on-scroll and glassmorphism state
    const header = document.querySelector('[data-header]');
    if (header) {
      let lastY = window.scrollY;
      
      const updateHeader = () => {
        const y = window.scrollY;
        
        // Add glassmorphism when scrolled down
        if (y > 20) {
          header.classList.add('is-sticky');
        } else {
          header.classList.remove('is-sticky');
        }

        // Hide on scroll down, show on scroll up
        if (y > 100 && y > lastY) {
          header.classList.add('up');
        } else {
          header.classList.remove('up');
        }
        lastY = y;
      };

      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader(); // init
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Trigger hero load animation
  window.addEventListener('load', () => {
    document.documentElement.classList.add('js');
    document.body.classList.add('loaded');
  });
  // Fallback if load fires before listener
  if (document.readyState === 'complete') {
    document.documentElement.classList.add('js');
    document.body.classList.add('loaded');
  }

  } catch(e) { console.error(e); }
})();
})();
